export default function ImagesModalController(
  $scope,
  $timeout,
  openingPage,
  allCategories,
  getImageForEdit,
  imagesService,
  imagesHttpService,
  $uibModalInstance,
  ivhTreeviewMgr,
  NotificationService,
  HTTP_CODE,
  IMAGES,
) {
  var vm = this;
  vm.isLoading = false;
  vm.selectedCategories = imagesService.selectedCategories;
  vm.selectedTags = [];
  vm.treeviewIcons = imagesService.treeviewIcons;
  vm.currentPage = openingPage;
  vm.categories = allCategories;
  vm.image = getImageForEdit;
  vm.errorMessages = [];
  vm.cropItem = [];
  vm.imageFile = null;
  vm.imageData = {
    name: null,
    type: null,
    sortOrder: 0,
  };
  vm.uploadImage = uploadImage;
  vm.updateImage = updateImage;
  vm.deleteImage = deleteImage;
  vm.closeModal = closeModal;
  init();

  function init() {
    vm.selectedCategories = imagesService.resetAll();
    ivhTreeviewMgr.deselectAll(vm.categories.categories[0]);
    ivhTreeviewMgr.collapseRecursive(vm.categories.categories[0], vm.categories.categories[0].children);
    if (vm.image) {
      vm.selectedTags = vm.image.tags;
      vm.imageName = vm.image.name;
      $timeout(function() {
        ivhTreeviewMgr.selectEach(vm.categories.categories[0].children, vm.image.categories);
        prepareCategoriesForEdit(vm.image.categories);
      }, 100);
    }
  }

  function prepareCategoriesForEdit() {
    vm.categories.categories[0].children.forEach(function(node) {
      if (node.selected) {
        node.children.forEach(function(children) {
          if (children.selected) {
            imagesService.addNodeToSelectedCategories(children);
          }
        });
        imagesService.addNodeToSelectedCategories(node);
      }
      if (node.__ivhTreeviewIndeterminate) {
        node.children.forEach(function(children) {
          if (children.selected) {
            imagesService.addNodeToSelectedCategories(children);
          }
        });
      }
    });
  }
  vm.editSelectedCategorie = function(node, isSelected, tree) {
    var rootNode = 1;
    if (!node.selected) {
      imagesService.removeNodeFromSelected(node, tree);
      return;
    }
    node.children.forEach(function(subCategorie) {
      if (!vm.selectedCategories.includes(node.name)) {
        imagesService.addNodeToSelectedCategories(subCategorie);
      }
    });
    if (node.parentId > rootNode && node.__ivhTreeviewIndeterminate) {
      imagesService.addNodeToSelectedCategories(parent);
    }
    var hasParent = imagesService.getNodeParent(node);
    if (!hasParent) {
      ivhTreeviewMgr.deselectAll(tree);
      tree.forEach(function(node) {
        node.selected = false;
      });
    }
    node.children.forEach(function(subCategorie) {
      if (!vm.selectedCategories.includes(subCategorie.name)) {
        ivhTreeviewMgr.deselect(tree, subCategorie); //deselect because plugin select all nodes recusively.
      }
    });
    imagesService.addNodeToSelectedCategories(node);
  };
  vm.landscapeDzOps = {
    url: function() {
      return false;
    },
    accept: function(file, done) {
      file.rejectDimensions = function() {
        NotificationService.error('File ' + file.name + ' has invalid width or height.');
        done();
      };
      file.acceptDimensions = function() {
        done();
      };
    },
    maxFiles: 1,
    autoProcessQueue: false,
    acceptedFiles: 'image/jpeg, image/png, image/gif',
  };
  vm.landscapeDzCallbacks = {
    thumbnail: function(file) {
      if (file.status === 'error') {
        NotificationService.error('File ' + file.name + ' has invalid format');
        return;
      }
      file.acceptDimensions();
      vm.cropItem.push(getCropItem(IMAGES.DEFAULT.TYPE, file));
      goToCrop(vm.cropItem);
    },
  };
  vm.storeTag = function(key) {
    var enter = 13,
      spacebar = 32;
    if (key === enter || key === spacebar || !key) {
      var isRepeated = vm.selectedTags.find(function(tag) {
        return tag === vm.tag;
      });
      if (isRepeated) {
        return;
      }
      if (vm.tag) {
        vm.selectedTags.push(vm.tag);
        vm.tag = null;
      }
    }
  };
  vm.deleteTag = function(tag) {
    var toDelete = vm.selectedTags.indexOf(tag);
    if (toDelete > -1) {
      vm.selectedTags.splice(toDelete, 1);
    }
  };
  $scope.$watch('vm.currentPage', function resetUploadData() {
    if (vm.currentPage === 1 && vm.cropItem.length) {
      vm.landscapeDzMethods.removeAllFiles();
      vm.cropItem = [];
    }
  });

  function getCropItem(type, file) {
    return {
      sortOrder: 0,
      type: type,
      name: file.name,
      height: file.height,
      width: file.width,
      file: file,
    };
  }

  function getDropzoneMessageLayer(dropzone) {
    return angular.element(dropzone.element).children('.dz-message')[0];
  }

  function goToCrop(image) {
    if (!image) {
      return;
    }
    vm.currentPage = 2;
    vm.items = image;
    vm.cropOps = {
      aspectRatio: 1,
      resultImageFormat: 'image/jpeg',
      resultImageSize: null,
      areaInitSize: null,
      areaInitCoords: {
        x: 0,
        y: 0,
      },
    };
    loadImage();
  }

  function loadImage() {
    vm.currentItem = vm.items[0];
    var clientWidth = angular.element('#cropContainer')[0].clientWidth;
    var ratio = clientWidth / vm.currentItem.file.width;
    if (ratio > 1) {
      ratio = 1;
    }
    vm.height = vm.currentItem.file.height * ratio;
    setCropAreaSize(ratio);
    vm.isLoading = false;
  }

  function setCropAreaSize(ratio) {
    vm.cropOps.aspectRatio = IMAGES.DEFAULT.ASPECT_RATIO;
    vm.cropOps.areaInitSize = {
      h: IMAGES.DEFAULT.MIN_HEIGHT * ratio,
      w: IMAGES.DEFAULT.MIN_WIDTH * ratio,
    };
    vm.cropOps.resultImageSize = {
      h: IMAGES.DEFAULT.MIN_HEIGHT,
      w: IMAGES.DEFAULT.MIN_WIDTH,
    };
  }

  function prepareImageForSave() {
    var selectedCategoriesid = [];
    vm.selectedCategories.forEach(function(categorie) {
      selectedCategoriesid.push(categorie.id);
    });
    var defaultImageDto = {
      name: vm.imageName,
      tags: vm.selectedTags,
      categories: selectedCategoriesid,
      imageData: vm.currentItem.dataUrl,
    };
    return defaultImageDto;
  }

  function uploadImage() {
    if (!vm.currentItem) {
      return;
    }
    var defaultImageDto = prepareImageForSave();
    defaultImageDto.imageData = vm.currentItem.dataUrl;
    vm.errorMessages = [];
    vm.isLoading = true;
    imagesHttpService
      .uploadImage(defaultImageDto)
      .then(NotificationService.success('Image successfully uploaded'))
      .then(function(res) {
        if (res && res.data) {
          imagesHttpService.getImageById(res.data).then(function(res) {
            vm.image = res.data;
          });
        }
      })
      .catch(handleUploadFail)
      .finally(function() {
        vm.isLoading = false;
      });
  }

  function updateImage() {
    var defaultImageDto = prepareImageForSave();
    if (!vm.currentItem.dataUrl) {
      defaultImageDto.imageData = vm.image.url;
    }
    vm.isLoading = true;
    imagesHttpService
      .updateImage(vm.image.id, defaultImageDto)
      .then(NotificationService.success('Image successfully updated'))
      .then(closeModal)
      .catch(handleUploadFail)
      .finally(function() {
        vm.isLoading = false;
        closeModal();
      });
  }

  function deleteImage(imageId) {
    if (confirm('Are you sure you want to delete this image? The image will be deleted from all the categories where it was added')) {
      vm.isLoading = true;
      imagesHttpService
        .deleteImageById(imageId)
        .then(NotificationService.success('Image deleted'))
        .then(closeModal)
        .catch(handleUploadFail)
        .finally(function() {
          vm.isLoading = false;
        });
    }
  }

  function handleUploadFail(res) {
    var msg = '';
    if (res.status === HTTP_CODE.STATUS.BAD_REQUEST) {
      msg = 'Error uploading image to S3. Check error messages table at the bottom of the page';
      parseErrorResponse(res.data.errors);
    }
    if (res.status === HTTP_CODE.STATUS.INTERNAL_SERVER_ERROR) {
      msg = 'Error uploading image to S3. Failed connection';
    }
    NotificationService.error(msg);
  }

  function parseErrorResponse(errors) {
    var errorResponseMessages;
    if (!(errors && errors.length)) {
      return;
    }
    vm.errorMessages = errors.map(function(row) {
      return row.message;
    });
  }

  function closeModal() {
    $uibModalInstance.close(vm.image);
  }
}



// WEBPACK FOOTER //
// ./src/app/images/imagesModal.controller.js